import React from "react";
import { Col, Container, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import useAuth from "../custom-hooks/useAuth";
import "../styles/admin-nav.css";

const AdminNav = () => {
  const { currentUser } = useAuth();

  const admin__nav = [
    {
      display: "Dashboard",
      path: "/dashboard",
    },
    {
      display: "All-Products",
      path: "/dashboard/all-products",
    },
    {
      display: "Orders",
      path: "/dashboard/orders",
    },
    {
      display: "Users",
      path: "/dashboard/users",
    },
  ];
  return (
    <>
      <header className="header__admin">
        <div className="admin__nav-top">
          <Container>
            <div className="admin__nav-wrapper-top">
              <div className="logo">
                <h2>Onlinestore</h2>
              </div>
              <div className="search__box">
                <input type="text" placeholder="Search ..." />
                <span>
                  <i className="ri-search-line"></i>
                </span>
              </div>
              <div className="admin__nav-top-right">
                <span>
                  <i className="ri-notification-3-line"></i>
                </span>
                <span>
                  <i className="ri-settings-2-line"></i>
                </span>
                {currentUser && (
                  <img src={currentUser.photoURL} alt={"user-photo"} />
                )}
              </div>
            </div>
          </Container>
        </div>
      </header>
      <section className="admin__menu p-0">
        <Container>
          <Row>
            <div className="admin__navigation">
              <ul className="admin__menu-list">
                {admin__nav.map((item, index) => (
                  <li className="admin__menu-item" key={index}>
                    <NavLink
                      to={item.path}
                      className={(navClass) =>
                        navClass.isActive ? "active-admin" : ""
                      }
                    >
                      {item.display}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AdminNav;
